/**
 * How sizes, lengths and moments read in the interface, the same on every
 * page and in every framework. Dates and times follow the viewer's locale.
 */

/** A file size: 512 B, 1.5 KB, 120 KB, 2.5 MB, 3.00 GB. */
export function formatBytes(n: number): string {
  if (n < 1024) return `${n} B`
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(n < 10 * 1024 ? 1 : 0)} KB`
  if (n < 1024 * 1024 * 1024) return `${(n / (1024 * 1024)).toFixed(1)} MB`
  return `${(n / (1024 * 1024 * 1024)).toFixed(2)} GB`
}

/** A length on a badge: 0:07, 12:34, 1:02:03; –:–– when unknown. */
export function formatDuration(ms: number | null | undefined): string {
  if (ms === null || ms === undefined || !Number.isFinite(ms)) return '–:––'
  const total = Math.max(0, Math.round(ms / 1000))
  const h = Math.floor(total / 3600)
  const m = Math.floor((total % 3600) / 60)
  const s = total % 60
  const mm = h > 0 ? String(m).padStart(2, '0') : String(m)
  return `${h > 0 ? `${h}:` : ''}${mm}:${String(s).padStart(2, '0')}`
}

/** A moment with its date: "Sep 27, 2026, 11:25 AM" in English. */
export function formatDateTime(ms: number): string {
  return new Date(ms).toLocaleString([], { dateStyle: 'medium', timeStyle: 'short' })
}

/** The time of day only: "11:25 AM" in English; empty for none. */
export function formatTimeOfDay(ms: number | null | undefined): string {
  if (!ms) return ''
  return new Date(ms).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
}
